import Swiper from "swiper/bundle";
import { Fancybox } from "@fancyapps/ui";

export default class Sliders {
  constructor(dom) {
    this.dom = dom;
    // this.numChar = this.dom.getAttribute("js-dummytext");

    // this.BgSlider();
    // this.initWorkshopSlider();
    // this.initBigSlider();
    // this.initProductsSilder();
    // this.initProductDetailsSlider();
    // this.fancybox();

    // window.addEventListener("resize", () => this.resize());
    let allSliders = document.querySelectorAll(".swiper");
    for (let sl of allSliders) {
      if (sl.classList.contains("bg-slider")) {
        this.BgSlider(sl)
      } else if (sl.classList.contains("hm-workshops-slider")) {
        this.initWorkshopSlider(sl)
      } else if (sl.classList.contains("bg-slider-container")) {
        this.initBigSlider(sl)
      } else if (sl.classList.contains("hm-product-slider")) {
        this.initProductsSilder(sl)
      } else if (sl.classList.contains("ps-main-slider")) {
        this.initProductDetailsSlider()
        this.fancybox()
      }

    }
  }

  BgSlider(sl) {
    const bgSwiper = new Swiper(sl, {
      // Optional parameters
      watchOverflow: true,
      speed: 650,
      // If we need pagination
      pagination: {
        el: ".swiper-pagination.bg-slider--pagination",
        clickable: true,
      },
    });
  }
  initWorkshopSlider(sl) {
    const hmPswiper = new Swiper(sl, {
      // Optional parameters
      // direction: "vertical",
      slidesPerView: 1.35,
      // slidesPerGroup: 1,
      spaceBetween: 20,
      // grabCursor: true,
      watchOverflow: true,
      slidesOffsetAfter: 10,
      slidesOffsetBefore: 10,

      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 25,
          slidesOffsetAfter: 10,
          slidesOffsetBefore: 10,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 25,
          slidesOffsetAfter: 25,
          slidesOffsetBefore: 25,
        },
      },

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
      },

      // Navigation arrows
      navigation: {
        nextEl: ".hm-workshops-slider .swiper-button-next",
        prevEl: ".hm-workshops-slider .swiper-button-prev",
      },
    });

  }

  initBigSlider(sl) {
    const BgSswiper = new Swiper(sl, {
      // Optional parameters

      // loop: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      roundLengths: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      centeredSlides: true,

      breakpoints: {
        992: {
          spaceBetween: 30,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".bg-slider-container .swiper-button-next",
        prevEl: ".bg-slider-container .swiper-button-prev",
      },
    });

  }

  initProductsSilder(sl) {
    const hmPswiper = new Swiper(sl, {
      // Optional parameters
      // direction: "vertical",
      slidesPerView: 1.5,
      // slidesPerGroup: 1,
      spaceBetween: 20,
      // grabCursor: true,
      watchOverflow: true,
      slidesOffsetAfter: 10,
      slidesOffsetBefore: 10,

      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 25,
          slidesOffsetAfter: 10,
          slidesOffsetBefore: 10,
        },

        992: {
          slidesPerView: 3.5,
          spaceBetween: 25,
          slidesOffsetAfter: 25,
          slidesOffsetBefore: 25,
        },
      },

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
      },

      // Navigation arrows
      navigation: {
        nextEl: ".hm-product-slider .swiper-button-next",
        prevEl: ".hm-product-slider .swiper-button-prev",
      },
    });

  }

  initProductDetailsSlider() {
    var thumbSlider = new Swiper(".ps-thumb-slider", {
      spaceBetween: 10,
      slidesPerView: 3.8,
      freeMode: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,

      breakpoints: {
        768: {
          slidesPerView: 3.8,
        },
        992: {
          slidesPerView: 7.5,
        },
      },
    });
    var mainSlider = new Swiper(".ps-main-slider", {
      spaceBetween: 0,
      speed: 650,

      observer: true,
      observeParents: true,

      navigation: {
        nextEl: ".ps-main-slider--arrow.swiper-button-next",
        prevEl: ".ps-main-slider--arrow.swiper-button-prev",
      },
      thumbs: {
        swiper: thumbSlider,
      },
    });

    document.addEventListener('handleProductDetailsSlider', (e) => {
      switch (e.detail.type) {
        case 'slideTo':
          let index = 0
          mainSlider.slides.forEach((item, i) => {
            if (item.dataset.preset_id == e.detail.value) {
              index = i
            }
          });
          mainSlider.slideTo(index)
          break;
        default:
          break;
      }
    }, false)


  }

  fancybox() {
    // console.log("gere");
    Fancybox.bind('[data-fancybox="ProductD_Slider"]', {
      animated: false,
      dragToClose: false,
      Toolbar: false,
      arrows: false,
      closeButton: "top",

      Image: {
        zoom: false,
      },
      Thumbs: false,
    });
  }
}
